import router from '../router'

export const errorInterceptor = error => {
  if (error.response) {
    const message = error.response.data.message
    if (error.response.status === 401) {
      console.log('Not authorised')
      console.log('pushing to login')
      router.push('/login')
    }
    return Promise.reject(message)
  }
}
